import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const RemoveUser = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17 11h5m-8.5-4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M3.433 16.862C4.674 14.554 7.022 13 10 13s5.326 1.554 6.567 3.862C17.404 18.42 15.973 20 14.205 20h-8.41c-1.767 0-3.199-1.58-2.362-3.138'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M5.365 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0'
          fill='currentColor'
        />
        <path
          d='M2.144 17.853C3.3 14.726 6.143 12.5 9.864 12.5c3.722 0 6.565 2.226 7.722 5.353a2.21 2.21 0 0 1-.391 2.225 2.65 2.65 0 0 1-2.027.922H4.562a2.65 2.65 0 0 1-2.027-.922 2.21 2.21 0 0 1-.391-2.225'
          fill='currentColor'
        />
        <path
          d='M16.615 10.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
